export default __webpack_public_path__ + "static/media/querelle_detail1.8b88d790.jpg";